import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";
import mixpanel from 'mixpanel-browser';
import { tracking } from './tracking';
import { initTarteaucitron } from './tarteaucitron-init';
import { initAuthModalAjaxForms } from './auth/authModalAjax';
initTarteaucitron();
initAuthModalAjaxForms();

tracking.init({
    mixpanelInstance: mixpanel,
    mixpanelToken: window.MH_MIXPANEL_TOKEN,
    websiteContext: window.MH_WEBSITE_CONTEXT,
    userContext: window.MH_USER_CONTEXT,
    queuedEvents: window.MH_QUEUED_EVENTS,
});
tracking.pageViewed(detectPageType());

function detectPageType() {
    const path = window.location.pathname;
    if (path === '/' || path.match(/^\/[a-z]{2}\/?$/)) return 'home';
    if (path.includes('/map/')) return 'map';
    if (path.includes('/plans')) return 'plans';
    if (path.includes('/product')) return 'product';
    if (path.includes('/checkout') || path.includes('/payment')) return 'checkout';
    if (path.includes('/landing/') || path.includes('-pass')) return 'landing';
    return 'static';
}

const root = document.documentElement;
const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
const marqueeContent = document.querySelector("ul.marquee-content");

if (marqueeContent) {
    root.style.setProperty("--marquee-elements", marqueeContent.children.length);

    for(let i=0; i<marqueeElementsDisplayed; i++) {
        marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
    }
}

if(window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash === 'modalBuyProduct') {
        window.location.replace(website.full_url + '/plans');
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('esource')) {
    const esource = urlParams.get('esource');
    if (esource) {
        fetch(window.location.origin + '/set-source', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({esource: esource})
        })
    }
}

if (typeof sentryDns !== 'undefined' && sentryDns) {
    Sentry.init({
        dsn: sentryDns,
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });

    if (typeof sentryUserId !== 'undefined') {
        Sentry.setUser({email: sentryUserId});
    }
}

/**
 * Listen to scroll to change header opacity class
 */
function checkScroll() {
    const navbar = document.querySelector('.navbar');
    const scrolledClass = 'scrolled';
    const startY = navbar.offsetHeight * 2; // The point where the navbar changes in px

    if (window.scrollY > startY) {
        navbar.classList.add(scrolledClass);
    } else {
        navbar.classList.remove(scrolledClass);
    }
}

const navbar = document.querySelector('.navbar');
if (navbar) {
    window.addEventListener("scroll", checkScroll);
    window.addEventListener("load", checkScroll);
    window.addEventListener("resize", checkScroll);
}

/** fix height with bottom bar on android & iphone (Fix hidden cart validate button) */
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
